// extracted by mini-css-extract-plugin
export default {"top-bar":"topBar_top-bar__tFV5w","contact-info":"topBar_contact-info__rOehp","social-icons":"topBar_social-icons__5VrMD","svg":"topBar_svg__A5Zfy","a":"topBar_a__H8ZNM"};